import { Button } from "@/components/ui/button";
import heroImage from "@/assets/hero-dock.jpg";
import parkRowLogo from "@/assets/park-row-logo.png";

const HeroSection = () => {
  const scrollToMailingList = () => {
    const element = document.getElementById("mailing-list");
    element?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden safe-top">
      <img
        src={heroImage}
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-center"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background/80" />
      <div className="relative z-10 container mx-auto px-4 text-center pt-16 md:pt-0">
        <img 
          src={parkRowLogo} 
          alt="Park Row" 
          className="w-48 md:w-96 mx-auto mb-4 md:mb-6 drop-shadow-2xl"
          loading="eager"
        />
        <h1 className="text-[22px] md:text-[36px] font-bold tracking-[0.02em] mb-5 md:mb-7 text-foreground bg-card/70 p-6 md:p-10 rounded-2xl md:rounded-3xl inline-block text-center uppercase" style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)' }}>
          The National Band of Texas
        </h1>
        <div className="flex gap-4 justify-center flex-wrap">
          <Button size="lg" className="bg-card hover:bg-card/90 active:bg-card/80 text-foreground border-0 text-[15px] font-bold tracking-[0.03em] uppercase h-12 md:h-11 px-6 touch-target tap-highlight-none" onClick={scrollToMailingList}>
            MAILING LIST
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
